export const findAssigmentItem = (items: any, id: string) =>
  items.find(({ refId }: any) => refId === id);
